var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"sm8":"","md6":"","lg4":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("Cadava")])],1),_c('v-card-text',[_c('login-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }